const { HTTP } = require('./http')

export const session = {
  active: false,
  idUsuario: null,
  usuario: null,
  poligono: null,
  async login (numeroEmpleado, password) {
    const { data } = await HTTP.post('login/autenticar', {
      numeroEmpleado,
      password
    })

    if (data === false) {
      throw Error('Verifique que el usuario y la contraseña sean los correctos')
    }

    const { error, id_usuario: idUsuario, usuario, poligono } = data

    if (error) throw new Error('error')

    this.idUsuario = idUsuario
    this.usuario = usuario
    this.poligono = JSON.parse(poligono)
    this.active = true

    setSession({ idUsuario, usuario, poligono })

    return true
  },
  getData () {
    return {
      idUsuario: this.idUsuario,
      usuario: this.usuario,
      poligono: this.poligono,
      active: this.active
    }
  },
  logout () {
    this.active = false
    this.idUsuario = null
    this.usuario = null
    this.poligono = null
  }
}

const initSession = () => {
  const dataSesion = JSON.parse(sessionStorage.getItem('sesion')) || null

  if (!dataSesion) return

  const { idUsuario, usuario, poligono } = dataSesion

  session.idUsuario = idUsuario
  session.usuario = usuario
  session.poligono = JSON.parse(poligono)
  session.active = true
}

const setSession = (sesion) => {
  sessionStorage.setItem('sesion', JSON.stringify(sesion))
}

initSession()
